import styled from '@emotion/styled';
import {Box} from '@mui/material';

export const BackgroundBoxWrapper = styled(Box)<{
    backgroundColor: string;
    isDesktop: boolean;
    pTop?: number;
}>(({backgroundColor, isDesktop, pTop}) => ({
    paddingTop: pTop ? pTop : 64,
    paddingBottom: 64,
    paddingLeft: isDesktop ? 128 : 54,
    paddingRight: isDesktop ? 128 : 54,
    margin: 0,
    backgroundColor: backgroundColor,
}));

export const BackgroundImageWrapper = styled(Box)<{backgroundImageUrl: string}>(({backgroundImageUrl}) => ({
    margin: 0,
    backgroundImage: `url('${backgroundImageUrl}')`,
    backgroundSize: 'cover',
}));

export const Wrapper = styled(Box)<{isDesktop: boolean}>(({isDesktop}) => ({
    paddingTop: 64,
    paddingBottom: 64,
    paddingLeft: isDesktop ? 128 : 54,
    paddingRight: isDesktop ? 128 : 54,
    backgroundColor: 'rgba(0, 0, 0, 0.32)',
}));
